{
  "redirect": {
    "head": {
      "tag": "THE DEC ENERGY SOLUTION",
      "title": "<h2>Discover the benefits of adopting our model</h2>"
    },
    "left": {
      "title": "<h3>Unlock the full potential of your capital and grow your asset portfolio</h3>",
      "cta": "For independent producers"
    },
    "right": {
      "title": "<h3>Accelerate your energy transition while maintaining ownership of your plants</h3>",
      "cta": "For utilities"
    }
  },
  "numeric-example": {
    "titleText": {
      "tag": "EXAMPLE CASE",
      "title": "<h2>Example application of the DEC Energy model</h2>",
      "description": "Scroll through the following pages to view a numerical example of the benefits obtained by a producer adopting the DEC Energy model on one of their portfolio plants."
    },
    "title": {
      "title": "<h3>By applying the DEC Energy model</h3>",
      "description": "<green>Multiply</green> your capital to build more assets while <green>de-risking</green> the first 10 years of your investment"
    },
    "plant-details": {
      "disclaimer": "The simulation in no way constitutes a quote from DEC.\n *with tracking system. production verified with PVGIS.\n **100% merchant based on Aurora curves",
      "rental-title": "Rental information",
      "plant-title": "Plant information",
      "plant-left": [
        "Peak Power",
        "Specific production",
        "Total investment",
        "Equity investment",
        "Project financing",
        "Interest rate",
        "Debt duration",
        "Average energy sale price",
        "Maintenance costs"
      ],
      "plant-right": [
        "4'989 kWp",
        "1'762 kWh/kWp",
        "€ 5'177'228",
        "20.2% (€ 1'045'800)",
        "79.8% (€ 4'131'428)",
        "4.60%",
        "20 years",
        "71.94 €/MWh",
        "11.52 €/MWh"
      ],
      "rental-left": [
        "Rental duration",
        "% of asset rented",
        "Asset management fee"
      ],
      "rental-right": ["10 years", "95%", "21.56 €/MWh"]
    },
    "keep": {
      "title": "Keep the asset",
      "elements": [
        "Revenue in year 0 (advance payment)",
        "Revenue years 1-10",
        "OPEX & financial costs years 1-10",
        "Total after 10 years",
        "",
        "Equity IRR after 10 years",
        "Equity ROI after 10 years",
        "",
        "Equity IRR after 35 years",
        "Equity ROI after 35 years"
      ]
    },
    "dec": {
      "title": "Rent with DEC",
      "elements": [
        "Revenue in year 0 (advance payment)",
        "Revenue years 1-10 (incl. fees)",
        "OPEX & financial costs years 1-10",
        "Total after 10 years",
        "",
        "Equity IRR after 10 years",
        "Equity ROI after 10 years",
        "",
        "Equity IRR after 35 years",
        "Equity ROI after 35 years"
      ]
    },
    "YearTable": {
      "title": {
        "title": "<h3>Detailed results</h3>",
        "description": "Year-by-year figures applying the DEC Energy model. (data in '000)"
      },
      "entries": [
        "",
        "Revenue",
        "OPEX costs",
        "Financial costs",
        "Net asset cash flow",
        "Distribution",
        "Net after distribution"
      ]
    },

    "gain-recap": [
      "advance payment",
      "of unlocked equity",
      "leverage on equity capital"
    ]
  },
  "calendly": {
    "tag": "DISCOVER ALL THE BENEFITS",
    "title": "<h2>Unlock your capital now by renting your photovoltaic plants</h2>",
    "description": "<b>Book a meeting with our experts</b> to receive a personalized analysis of the benefits of adopting DEC Energy."
  }
}
